import "./Certifications.css";
import Footer from "./Footer";
import { useState } from "react";

import cert1 from "../assets/cer-img1.png";
import cert2 from "../assets/cer-img2.png";
import cert3 from "../assets/cer-img3.png";
import cert4 from "../assets/cer-img4.png";
import cert5 from "../assets/cer-img5.png";
import cert6 from "../assets/cer-img6.png";
import cert7 from "../assets/cer-img7.png";
import cert8 from "../assets/cer-img8.png";
import cert9 from "../assets/cer-img9.png";
import cert10 from "../assets/cer-img10.png";
import cert11 from "../assets/cer-img11.png";
import cert12 from "../assets/cer-img12.png";
import cert13 from "../assets/cer-img13.png";

// NEW: ISO 50001 and TISAX
import cert14 from "../assets/ISO 50001 image part1.png";
import cert15 from "../assets/ISO 50001 image part2.png";
import cert16 from "../assets/TISAX certificates image.png";

export default function Certificates() {
  const [activeCert, setActiveCert] = useState("tkp");

  const certificatesData = {
    tkp: [cert1, cert2],
    oragadam: [cert3, cert4],
    usa: [cert5, cert6],
    is617: [cert7],
    iso14001: [cert8, cert9],
    iso45001: [cert10, cert11],
    iso27001: [cert12, cert13],
    iso50001: [cert14, cert15], // NEW
    tisax: [cert16], // NEW
  };

  return (
    <section  id="certificates">
      <div className="cert-page">
        <h2 className="cert-title">Certifications</h2>
        <div className="cert-underline"></div>

        <div className="cert-container">
          {/* LEFT PANEL */}
          <div className="cert-left">
            <div className="cert-box">

              {/* QUALITY */}
              <div className="cert-heading">Quality & Automotive Standards</div>
              <ul>
                <li
                  className={activeCert === "tkp" ? "active" : ""}
                  onClick={() => setActiveCert("tkp")}
                >
                  IATF 16949 (TKP)
                </li>
                <li
                  className={activeCert === "oragadam" ? "active" : ""}
                  onClick={() => setActiveCert("oragadam")}
                >
                  IATF 16949 (Oragadam)
                </li>
                <li
                  className={activeCert === "usa" ? "active" : ""}
                  onClick={() => setActiveCert("usa")}
                >
                  IATF 16949 (US)
                </li>
                <li
                  className={activeCert === "is617" ? "active" : ""}
                  onClick={() => setActiveCert("is617")}
                >
                  IS 617
                </li>
              </ul>

              {/* ENVIRONMENT */}
              <div className="cert-heading">
                Environmental & Sustainability Standards
              </div>
              <ul>
                <li
                  className={activeCert === "iso14001" ? "active" : ""}
                  onClick={() => setActiveCert("iso14001")}
                >
                  ISO 14001
                </li>
                {/* NEW: ISO 50001 */}
                <li
                  className={activeCert === "iso50001" ? "active" : ""}
                  onClick={() => setActiveCert("iso50001")}
                >
                  ISO 50001
                </li>
              </ul>

              {/* HEALTH & SAFETY */}
              <div className="cert-heading">Health & Safety Standards</div>
              <ul>
                <li
                  className={activeCert === "iso45001" ? "active" : ""}
                  onClick={() => setActiveCert("iso45001")}
                >
                  ISO 45001
                </li>
              </ul>

              {/* INFORMATION SECURITY */}
              <div className="cert-heading">
                Information Security Standards
              </div>
              <ul>
                <li
                  className={activeCert === "iso27001" ? "active" : ""}
                  onClick={() => setActiveCert("iso27001")}
                >
                  ISO/IEC 27001
                </li>
                {/* NEW: TISAX */}
                <li
                  className={activeCert === "tisax" ? "active" : ""}
                  onClick={() => setActiveCert("tisax")}
                >
                  TISAX
                </li>
              </ul>

            </div>
          </div>

          {/* RIGHT PANEL */}
          <div className="cert-right">
            {certificatesData[activeCert]?.map((img, index) => (
              <div
                className={`cert-image ${activeCert === "tisax" ? "cert-image-crop" : ""}`}
                key={index}
              >
                <img
                  src={img}
                  alt={`Certificate ${index}`}
                  onContextMenu={(e) => e.preventDefault()}
                  draggable={false}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
}
